/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Principle_2_BodyInputs */

const en_about_principle_2_body = /** @type {(inputs: About_Principle_2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A focused scope, visible assumptions and working software to review. You should be able to understand what the system does.`)
};

const lv_about_principle_2_body = /** @type {(inputs: About_Principle_2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konkrēts darba apjoms, skaidri pieņēmumi un strādājoša programmatūra, ko varat izvērtēt. Jums jāspēj saprast, ko sistēma dara.`)
};

/**
* | output |
* | --- |
* | "A focused scope, visible assumptions and working software to review. You should be able to understand what the system does." |
*
* @param {About_Principle_2_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const about_principle_2_body = /** @type {((inputs?: About_Principle_2_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Principle_2_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_about_principle_2_body(inputs)
	return en_about_principle_2_body(inputs)
});